import { Translation } from "..";

const fr: Translation = {
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer",
    remove: "Retirer",
    submit: "Soumettre",
    back: "Retour",
    loading: "Chargement...",
    search: "Rechercher",
    yes: "Oui",
    no: "Non",
    close: "Fermer",
    confirm: "Confirmer",
    actions: "Actions",
    noData: "Aucune donnée disponible",
    error: "Une erreur est survenue",
    success: "Succès",
    required: "Ce champ est obligatoire",
    invalidUrl: "Saisissez une URL valide",
    nonNegativeNumber: "Saisissez un nombre entier superieur ou egal a 0",
    optional: "Optionnel",
    notSet: "Non défini",
    descriptionHint:
      "Veuillez être aussi détaillé et exhaustif que possible. Incluez le contexte, les objectifs, le comportement attendu et toute contrainte pertinente.",
  },
  nav: {
    dashboard: "Tableau de bord",
    newRequest: "Nouvelle demande",
    requests: "Demandes",
    inventory: "Inventaire",
    newInventory: "Nouvel élément d'inventaire",
    users: "Utilisateurs",
    profile: "Profil",
    admin: "Admin",
    language: "Langue",
    help: "Aide",
    manual: "Manuel utilisateur",
    logout: "Se déconnecter",
  },
  requests: {
    title: "Titre",
    description: "Description",
    audience: "Audience",
    audienceInternal: "Interne",
    audienceInternalInfo:
      "Choisissez cette option si l'application est destinée uniquement aux employés de Rotoblaas. Elle ne sera pas accessible depuis l'extérieur de l'entreprise.",
    audienceExternal: "Externe",
    audienceExternalInfo:
      "Choisissez cette option si l'application sera accessible à des personnes extérieures à Rotoblaas — par exemple via le site web, EService ou d'autres outils publics.",
    departments: "Départements",
    needsErpIntegration: "Nécessite une intégration ERP",
    needsErpIntegrationInfo:
      "Cochez cette option si l'application devra échanger des données ou s'intégrer avec d'autres systèmes du groupe. Exemples : Semiramis, Pimcore, EService, CRM.",
    participants: "Participants",
    participantsInfo: "Ajoutez des participants à notifier lors de la création de cette demande.",
    status: "Statut",
    statusDraft: "Brouillon",
    statusNew: "Ouvert",
    statusInProgress: "En cours",
    statusCompleted: "Terminé",
    responsibleDepartment: "Département Responsable",
    responsibleDepartmentIntegrations: "Intégrations",
    responsibleDepartmentSoftwareDevelopment: "Développement logiciel",
    responsibleDepartmentIct: "ICT",
    estimateDays: "Estimation (jours)",
    internalNotes: "Notes internes",
    approvedBy: "Approuvé par",
    approvedAt: "Approuvé le",
    createdBy: "Créé par",
    createdAt: "Créé le",
    supervisor: "Superviseur",
    approve: "Approuver",
    newRequest: "Nouvelle demande",
    viewRequestPageTitle: "Demande #{{id}}: {{title}}",
    editRequestPageTitle: "Modifier: {{title}}",
    allRequests: "Toutes les demandes",
    backToRequests: "Retour aux demandes",
    backToRequest: "Retour à la demande",
    filterAll: "Toutes",
    filterDraft: "Brouillon",
    filterNew: "Nouvelles",
    filterInProgress: "En cours",
    filterCompleted: "Terminées",
    approveSuccess: "Demande approuvée avec succès",
    submitSuccess: "Demande soumise avec succès",
    updateSuccess: "Demande mise à jour avec succès",
    managementSection: "Actions de gestion",
    auditTrail: "Journal d'audit",
    deleteRequest: "Supprimer la demande",
    confirmDeleteRequest: "Êtes-vous sûr de vouloir supprimer cette demande ? Cette action est irréversible.",
    deleteSuccess: "Demande supprimée avec succès",
    noRequests: "Aucune demande trouvée",
    typeLabel: "Demande de fonctionnalité",
  },
  inventory: {
    name: "Nom",
    description: "Description",
    improvementNotes: "Notes d'amélioration",
    improvementNotesInfo:
      "Ajoutez des points d'amélioration, des intégrations ERP ou tout ce que vous n'avez pas pu gérer de façon autonome.",
    githubUrl: "URL GitHub",
    deploymentLocation: "Emplacement de déploiement",
    deploymentLocationInfo: "Où le projet est-il sauvegardé ou installé ? Ex. SharePoint, serveur local…",
    audience: "Audience",
    audienceInternal: "Interne",
    audienceExternal: "Externe",
    participants: "Participants",
    status: "Statut",
    statusUnderReview: "En évaluation",
    statusTakenOver: "Pris en charge",
    statusRejected: "Rejeté",
    statusCompleted: "Terminé",
    rejectCause: "Cause du rejet",
    rejectCauseNotInteresting: "Pas intéressant",
    rejectCauseDuplicate: "Doublon",
    rejectCauseNonCompliant: "Non conforme",
    rejectCauseOutOfScope: "Hors périmètre",
    rejectCauseInsufficientInfo: "Informations insuffisantes",
    rejectCauseNotSustainable: "Non durable",
    rejectCauseOther: "Autre",
    rejectNote: "Note de rejet",
    attachments: "Pièces jointes",
    uploadAttachment: "Télécharger une pièce jointe",
    addAttachment: "Ajouter une pièce jointe",
    noAttachments: "Aucune pièce jointe",
    attachmentUploadFailed:
      "Échec du téléchargement d'une ou plusieurs pièces jointes. L'élément n'a pas été enregistré, veuillez réessayer.",
    createdBy: "Créé par",
    createdAt: "Créé le",
    newItem: "Nouvel élément d'inventaire",
    allItems: "Tous les éléments",
    viewInventoryPageTitle: "Élément #{{id}}: {{title}}",
    editInventoryPageTitle: "Modifier l'élément #{{id}}: {{title}}",
    backToInventory: "Retour à l'inventaire",
    backToInventories: "Retour aux inventaires",
    audienceExternalAlert:
      "Les éléments destinés à une audience externe doivent respecter les contraintes HTML et JS. Assurez-vous que le code respecte les standards web.",
    submitSuccess: "Élément d'inventaire soumis avec succès",
    updateSuccess: "Élément d'inventaire mis à jour avec succès",
    managementSection: "Gestion",
    noItems: "Aucun élément d'inventaire trouvé",
    filterAll: "Tous",
    filterUnderReview: "En évaluation",
    filterTakenOver: "Pris en charge",
    filterRejected: "Rejeté",
    filterCompleted: "Terminé",
    fileSize: "Taille",
    uploadedBy: "Téléchargé par",
    uploadedAt: "Téléchargé le",
    deleteAttachment: "Supprimer la pièce jointe",
    confirmDeleteAttachment: "Êtes-vous sûr de vouloir supprimer cette pièce jointe ?",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Tout marquer comme lu",
    markAsRead: "Marquer comme lu",
    noNotifications: "Aucune notification",
    unread: "non lues",
    seeAll: "Voir toutes les notifications",
    filterAll: "Toutes",
    filterUnread: "Non lues",
    actions: {
      new_inventory_item: "a ajouté un nouvel élément à l'inventaire",
      request_approved: "a approuvé une demande de développement",
    },
  },
  profile: {
    language: "Langue",
    manager: "Manager",
    noManager: "Aucun manager assigné",
    english: "English (UK)",
    usEnglish: "English (US)",
    italian: "Italiano",
    french: "Français",
    german: "Deutsch",
    spanish: "Español",
    saveLanguage: "Enregistrer la langue",
    languageSaved: "Langue enregistrée",
    title: "Profil Utilisateur & Paramètres",
    personalInfo: "Informations Personnelles",
    languageSettings: "Paramètres de Langue",
  },
  dashboard: {
    welcome: "Bienvenue",
    allRequests: "Toutes les demandes",
    allInventory: "Tous les éléments",
    myRequests: "Mes demandes",
    myInventory: "Mes éléments",
    recentNotifications: "Notifications récentes",
    createRequest: "Créer une demande",
    createInventory: "Ajouter un élément",
    statusNew: "Nouveau",
    statusInProgress: "En cours",
    statusCompleted: "Terminé",
    statusToApprove: "À approuver",
    total: "Total",
  },
  users: {
    allUsers: "Tous les utilisateurs",
    addUser: "Ajouter un utilisateur",
    name: "Nom",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    department: "Département",
    isAdmin: "Admin",
    lastAccess: "Dernier Accès",
    noUsers: "Aucun utilisateur trouvé",
    addUserSuccess: "Utilisateur ajouté avec succès",
    userNotFound: "Utilisateur non trouvé",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    roleAll: "Tous",
    roleAdmin: "Admin",
    roleNonAdmin: "Non-Admin",
    withAccess: "Avec Accès",
    withoutAccess: "Sans Accès",
  },
  admin: {
    title: "Admin",
    users: "Utilisateurs",
    noAdminEndpoint: "Note : la gestion des rôles utilisateur n'est pas encore disponible via l'API.",
    email: "Email",
    name: "Nom",
    isAdmin: "Admin",
    managerId: "ID Manager",
    createdAt: "Créé le",
  },
};

export default fr;
